import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isRequired } from '../../../utils/validation';

const PercentPersonOwnCompany = ({ values }) => (
  <Content>
    {({
      globalRadioError = '',
      personDetailsPercentageOwnCompany = '',
      personDetailsPercentageValue1,
      personDetailsPercentageValue2,
      personDetailsPercentageValue3
    }) => (
      <Field
        name="percentPersonOwnCompany"
        subscription={{ touched: true, error: true }}
        validate={isRequired}
      >
        {({ meta: { touched, error }, input }) => (
          <GenericFieldWrapper
            inputId="percentPersonOwnCompany"
            title={personDetailsPercentageOwnCompany}
            validationMessage={touched && !!error ? globalRadioError : ''}
          >
            <GenericRadio.InlineSet
              groupName="percentPersonOwnCompany"
              items={[
                {
                  id: personDetailsPercentageValue1,
                  labelText: personDetailsPercentageValue1
                },
                {
                  id: personDetailsPercentageValue2,
                  labelText: personDetailsPercentageValue2
                },
                {
                  id: personDetailsPercentageValue3,
                  labelText: personDetailsPercentageValue3
                }
              ]}
              {...input}
              selectedId={values.percentPersonOwnCompany}
              onChange={selectedId => {
                input.onChange(selectedId);
              }}
            />
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default PercentPersonOwnCompany;
